import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  Card,
  CardContent,
  makeStyles,
  useTheme
} from '@material-ui/core'
import noop from 'lodash/noop'
import Icon from '../atoms/Icon'
import Text from '../atoms/Text'
import { ICON_NAMES, TEXT_VARIANTS } from '../../constants'

const useStyles = makeStyles((theme) => ({
  card: ({ minHeight }) => ({
    minHeight: minHeight || '14rem',
    width: '100%',
    backgroundColor: theme.palette.wildSand,
    borderRadius: '0.5rem',
    textAlign: 'center'
  }),
  cardContent: {
    padding: '2rem !important'
  },
  icon: {
    padding: '1.5rem'
  },
  mainButton: {
    backgroundColor: theme.palette.cloudBurst,
    color: theme.palette.getContrastText(theme.palette.cloudBurst),
    '&:hover': {
      backgroundColor: theme.palette.mirage
    },
    borderRadius: 25,
    padding: '6px 22px 6px 16px',
    textTransform: 'none',
    fontWeight: 'bold',
    fontSize: '0.75rem'
  }
}))

const LinkSectionEmptyState = ({
  bodyText,
  minHeight,
  buttonLabel,
  onButtonClick,
  headerIconName
}) => {
  const theme = useTheme()
  const classes = useStyles({ minHeight })
  const iconProps = useMemo(
    () => ({
      customSize: 26,
      roundedBackground: theme.palette.gallery
    }),
    [theme]
  )

  return (
    <Card elevation={0} className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Icon
          name={headerIconName}
          {...iconProps}
          additionalClasses={classes.icon}
        />
        <Box my='1.5rem'>
          <Text
            textTransform='none'
            variant={TEXT_VARIANTS.subtitle2}
            text={bodyText}
          />
        </Box>
        <Button
          className={classes.mainButton}
          onClick={onButtonClick}
          endIcon={
            <Icon
              name='add'
              padding='0px'
              color={theme.palette.black}
              customSize={16}
              roundedBackground={theme.palette.white}
            />
          }
        >
          {buttonLabel}
        </Button>
      </CardContent>
    </Card>
  )
}

LinkSectionEmptyState.propTypes = {
  bodyText: PropTypes.string,
  minHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonLabel: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  headerIconName: PropTypes.oneOf(Object.values(ICON_NAMES)).isRequired
}

LinkSectionEmptyState.defaultProps = {
  onButtonClick: noop,
  minHeight: undefined,
  bodyText: ''
}

export default LinkSectionEmptyState
